import type { FaireProductEntity } from "../../entity_types/product";

export const p_62q2tycbv5: FaireProductEntity = {
  token: "p_62q2tycbv5",
  type: "product",
  name: "OJAI NUIT REED DIFFUSER",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/8e33a298b5fce6844010a902bfbd0088f4ca8b5b7b1c05e008f8de315592b595.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a60cb3f04b82655e953135eba86b726408117958f4df5d70bf0475cca92be9ba.jpeg",
    "https://cdn.faire.com/fastly/fdc5b9b609f2e81bce9be12a34c325cb9bf715f035b85ce412235f4264252c5c.jpeg"
  ],
  priceDollars: 19,
  description: "Introducing our new reed diffusers! Fill your space with your favorite Roen scent without the flame.\n\nReminiscent of a summer getaway spent in Ojai, this scent will transport you to a night under the stars with the clean scent of balsam fir and sandalwood balanced beautifully with airy top notes of fresh fig tree.\n\nbalsam fir, fig leaf, sandalwood, amber\n\nRoen is hand poured in our Southern California studio. All of our products are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n3 fl oz (88 ml), comes in our signature pink box.",
  tags: [],
  msrpDollars: 38,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:12.163Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
